import axios from "axios";
import moment from "moment";
import ACTIONS from "./types";
import API_ENDPOINTS from "../../configs/API_ENDPOINTS";

export const FetchAllDevicesWithNoPagination = () => (dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.FETCH_ALL_DEVICES_WITH_NO_PAGINATION,
    payload: { devices: [] },
  });
  axios
    .get(`${API_ENDPOINTS.DEVICES}?perPage=10000`)
    .then((res) => {
      handlAllDevicesListResonpse(res.data, dispatch);
    })
    .catch((err) => {
      console.log({ err });

      dispatch({
        type: ACTIONS.DEVICES.FETCH_ALL_DEVICES_LIST_FAILURE,
        payload: err,
      });
    });
};

export const handlAllDevicesListResonpse = (data, dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.FETCH_ALL_DEVICES_LIST_SUCCESS,
    payload: {
      devices: data.data,
      page: data.page,
      total: data.total,
      perPage: data.perPage,
      lastPage: data.lastPage,
    },
  });
};

export const FetchAllHeartBeatDevicesList = () => (dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.FETCH_ALL_DEVICES_LIST_START,
  });
  axios
    .get(`${API_ENDPOINTS.HEART_BEAT_DEVICES}`)
    .then((res) => {
      if (res.data.length === 0) return;
      handlAllDevicesListResonpse(res.data, dispatch);
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.DEVICES.FETCH_ALL_DEVICES_LIST_FAILURE,
        payload: err,
      });
    });
};

export const SetSelectedDeviceInfo = (selectedDeviceInfo) => (dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.SET_SELECTED_DEVICE_INFO,
    payload: selectedDeviceInfo,
  });
};
export const FetchAllDevicesList = () => (dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.FETCH_ALL_DEVICES_LIST_START,
  });
  axios
    .get(`${API_ENDPOINTS.DEVICES}`)
    .then((res) => {
      handlAllDevicesListResonpse(res.data, dispatch);
    })
    .catch((err) => {
      console.log({ err });

      dispatch({
        type: ACTIONS.DEVICES.FETCH_ALL_DEVICES_LIST_FAILURE,
        payload: err,
      });
    });
};

const buildPromiseArray = (selectedDevices, selectedStartDate, selectedEndDate) => {
  return selectedDevices.map((device) => {
    return axios.get(`${API_ENDPOINTS.DEVICES}/${device._id}/messages?startDate=${selectedStartDate}&endDate=${selectedEndDate}`);
  });
};

const _FetchSelectedDevicesListAsync = async (selectedStartDate, selectedEndDate, selectedDevices, dispatch) => {
  const promiseArray = buildPromiseArray(selectedDevices, selectedStartDate, selectedEndDate);
  try {
    const DevicesData = (await Promise.all(promiseArray)).map((res) => {
      return [...res.data];
    });
    dispatch({
      type: ACTIONS.DEVICES.UI.SWITCH_ELEVATION_TOGGLE,
      payload: !!(selectedDevices.filter((device) => device.device_type._id === "waterlevel").length > 0),
    });

    dispatch({
      type: ACTIONS.DEVICES.FETCH_SELECTED_DEVICES_LIST_SUCCESS,
      payload: {
        data: DevicesData,
        selectedDevices: selectedDevices,
        selectedStartDate: selectedStartDate,
        selectedEndDate: selectedEndDate,
      },
    });
  } catch (err) {
    dispatch({
      type: ACTIONS.DEVICES.FETCH_SELECTED_DEVICES_LIST_FAILURE,
      payload: err,
    });
  }
};

export const FetchSelectedDevicesList =
  (selectedStartDate = moment().subtract(1, "days").unix(), selectedEndDate = moment().unix(), selectedDevices, userAbility) =>
  (dispatch) => {
    dispatch({
      type: ACTIONS.DEVICES.FETCH_SELECTED_DEVICES_LIST_START,
    });

    if (selectedDevices.length > 0) {
      _FetchSelectedDevicesListAsync(selectedStartDate, selectedEndDate, selectedDevices, dispatch);
    } else {
      FetchAllDevicesList(userAbility)(dispatch);
    }
  };

export const SetNoDeviceSelected = () => async (dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.SET_NO_DEVICE_SELECTED,
  });
};

export const FetchAllDevicesModelsList =
  (devicesModelsList = []) =>
  (dispatch) => {
    dispatch({
      type: ACTIONS.DEVICES.FETCH_ALL_MODELS_LIST_START,
    });
    if (devicesModelsList.length !== 0) {
      dispatch({
        type: ACTIONS.DEVICES.SET_SELECTED_MODELS_LIST,
        payload: [...devicesModelsList],
      });
    } else {
      axios
        .get(`${API_ENDPOINTS.DEVICES}/devicemodels`)
        .then((res) => {
          Promise.all([
            dispatch({
              type: ACTIONS.DEVICES.FETCH_ALL_MODELS_LIST_SUCCESS,
              payload: res.data,
            }),
            dispatch({
              type: ACTIONS.DEVICES.SET_SELECTED_MODELS_LIST,
              payload: res.data,
            }),
          ]);
        })
        .catch((err) => {
          dispatch({
            type: ACTIONS.DEVICES.FETCH_ALL_MODELS_LIST_FAILURE,
            payload: err,
          });
        });
    }
  };

export const fetchDeviceTypeCategories = () => (dispatch) => {
  axios.get(API_ENDPOINTS.DEVICETYPE_CATEGORIES).then((res) => {
    dispatch({
      type: ACTIONS.DEVICES.SET_DEVICETYPE_CATEGORIES,
      payload: res.data,
    });
  });
};

export const setSelectedDeviceTypeCategories = (selectedDeviceTypeCategories) => (dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.SET_DEVICETYPE_CATEGORIES,
    payload: selectedDeviceTypeCategories,
  });
};

export const SetSelectedDevicesModelsList = (selectedDevicesModels) => (dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.SET_SELECTED_MODELS_LIST_START,
  });
  selectedDevicesModels.length <= 0
    ? dispatch({
        type: ACTIONS.DEVICES.SET_SELECTED_MODELS_LIST_FAILURE,
        payload: "No Models selected",
      })
    : dispatch({
        type: ACTIONS.DEVICES.SET_SELECTED_MODELS_LIST_SUCCESS,
        payload: selectedDevicesModels,
      });
};

export const setDevicesList = (selectedDevices) => (dispatch) => {
  Promise.all([
    dispatch({
      type: ACTIONS.DEVICES.SET_DEVICES_LIST,
      payload: selectedDevices ? [...selectedDevices] : [],
    }),
    dispatch({
      type: ACTIONS.DEVICES.SET_DEVICES_LIST_SUCCESS,
    }),
  ]);
};

export const StartDevicesFiltering = () => (dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.FILTERS_START,
  });
};

export const clearDevicesFilters = (devicesList, deviceTypeCategories, devicesModelsList) => (dispatch) => {
  Promise.all([
    dispatch({
      type: ACTIONS.DEVICES.CLEAR_FILTERS_START,
    }),
  ])
    .then(
      dispatch({
        type: ACTIONS.DEVICES.SET_DEFAULT_FILTERS_LISTS,
        payload: {
          devicesList,
          deviceTypeCategories,
          devicesModelsList,
        },
      })
    )
    .then(setDevicesList(devicesList)(dispatch))
    .then(
      dispatch({
        type: ACTIONS.DEVICES.CLEAR_FILTERS_SUCCESS,
        payload: [...devicesList],
      })
    );
};

const _getSelectedDeviceInfo = (deviceId, dispatch) => {
  if (deviceId) {
    axios.get(API_ENDPOINTS.DEVICE_DATA.replace("{device_id}", deviceId)).then((res) => {
      if (res.data._id === deviceId) {
        dispatch({
          type: ACTIONS.DEVICES.SELECTED_DEVICE_INFO,
          payload: res.data,
        });
      }
    });
  } else {
    dispatch({
      type: ACTIONS.DEVICES.NO_SELECTED_DEVICE_INFO,
      payload: {},
    });
  }
};

export const getDeviceById = (deviceId) => (dispatch) => {
  return axios.get(API_ENDPOINTS.DEVICES + "/" + deviceId);
};

export const getSelectedDeviceInfo = (deviceId) => (dispatch) => {
  if (deviceId) _getSelectedDeviceInfo(deviceId, dispatch);
  else
    dispatch({
      type: ACTIONS.DEVICES.SET_NO_DEVICE_SELECTED,
      payload: {},
    });
};

export const updateSelectedDeviceInfo = (deviceInfo, updateURL) => (dispatch) => {
  if (deviceInfo) {
    axios
      .patch(updateURL, deviceInfo)
      .then((res) => {
        dispatch({
          type: ACTIONS.DEVICES.UPDATE_SELECTED_DEVICE_INFO,
          payload: res.data.device,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }
};

export const getOrganizationAndDeviceInfoByIds = (selectedOrgId, selectedDeviceId) => (dispatch) => {
  if (selectedOrgId && selectedDeviceId) {
    axios
      .get(`${API_ENDPOINTS.ORGANIZATIONS}/${selectedOrgId}`)
      .then((res) => {
        const selectedOrganization = res.data;
        dispatch({
          type: ACTIONS.TRENDS.SET_SELECTED_ORGNANIZATION,
          payload: selectedOrganization,
        });
        if (selectedDeviceId) {
          // _getDeviceByOrganizationId(selectedOrgId, selectedDeviceId, dispatch);
        }
      })
      .catch((error) => {});
  }
};

const _getDeviceByOrganizationId = (selectedOrgId, selectedDeviceId, dispatch) => {
  if (selectedOrgId && selectedDeviceId) {
    axios.get(`${API_ENDPOINTS.ORGANIZATIONS}/${selectedOrgId}/devices/${selectedDeviceId}`).then((res) => {
      if (res.data._id === selectedDeviceId) {
        dispatch({
          type: ACTIONS.DEVICES.SELECTED_DEVICE_INFO,
          payload: res.data,
        });
      }
    });
  } else {
    dispatch({
      type: ACTIONS.DEVICES.SELECTED_DEVICE_INFO,
      payload: {},
    });
  }
};
export const getDeviceByOrganizationId = (selectedOrgId, selectedDeviceId) => (dispatch) => {
  _getDeviceByOrganizationId(selectedOrgId, selectedDeviceId, dispatch);
};

export const getDevicesLifecycles = () => (dispatch) => {
  axios.get(API_ENDPOINTS.DEVICES + "/lifecycles").then(({ data }) => {
    dispatch({
      type: ACTIONS.DEVICES.SET_DEVICES_LIFECYCLES,
      payload: [...data],
    });
  });
};

export const deleteSelectedDevice = (device_id) => (dispatch) => {
  return axios.delete(`${API_ENDPOINTS.DEVICES}/${device_id}?perm=true`).then((res) => {
    setTimeout(() => {
      dispatch({
        type: ACTIONS.DEVICES.SELECTED_DEVICE_DELETED,
      });
      return res;
    }, 2000);
  });
};

export const getDeviceContracts = (device_id) => (dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.SET_DEVICE_CONTRACTS_LIST_START,
  });
  return axios
    .get(`${API_ENDPOINTS.DEVICES}/${device_id}/contracts`)
    .then((res) => {
      dispatch({
        type: ACTIONS.DEVICES.SET_DEVICE_CONTRACTS_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.DEVICES.SET_DEVICE_CONTRACTS_LIST_FAILURE,
      });
    });
};

export const clearDeviceContracts = () => (dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.SET_DEVICE_CONTRACTS_LIST_START,
  });
};

export const removeDeviceFromContact = (device, contract) => (dispatch) => {
  if (contract) {
    dispatch({
      type: ACTIONS.DEVICES.REMOVE_DEVICE_FROM_CONTRACT_START,
    });
    axios
      .delete(`${API_ENDPOINTS.CONTRACTS}/${contract._id}/devices/${device._id}`)
      .then(() => {
        dispatch({
          type: ACTIONS.DEVICES.REMOVE_DEVICE_FROM_CONTRACT,
          payload: contract,
        });
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.DEVICES.REMOVE_DEVICE_FROM_CONTRACT_FALURE,
          payload: err,
        });
      });
  }
};

export const fetchDeviceOwners = (deviceId) => (dispatch) => {
  axios.get(API_ENDPOINTS.DEVICES + "/" + deviceId + "/organizations").then(({ data }) => {
    dispatch({
      type: ACTIONS.DEVICES.SET_DEVICE_OWNERS,
      payload: [...data],
    });
  });
};
export const fetchDeviceImages = (deviceId) => (dispatch) => {
  if (deviceId) {
    dispatch({
      type: ACTIONS.DEVICES.FETCHING_DEVICE_IMAGES_START,
    });
    axios
      .get(`${API_ENDPOINTS.DEVICES}/${deviceId}/images?`, {
        cache: false,
      })
      .then((res) => {
        dispatch({
          type: ACTIONS.DEVICES.FETCHING_DEVICE_IMAGES,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.DEVICES.FETCHING_DEVICE_IMAGES_FALURE,
          payload: err,
        });
      });
  }
};
export const removeDevicePicture = (deviceId, picId) => (dispatch) => {
  if (deviceId && picId) {
    dispatch({
      type: ACTIONS.DEVICES.FETCHING_DEVICE_IMAGES_START,
    });
    axios
      .delete(`${API_ENDPOINTS.DEVICES}/${deviceId}/images/${picId}`)
      .then((res) => {
        dispatch({
          type: ACTIONS.DEVICES.REMOVE_DEVICE_IMAGE,
          payload: picId,
        });
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.DEVICES.REMOVE_DEVICE_IMAGE,
          payload: err,
        });
      });
  }
};
export const uploadAllPictures = (selectedDeviceInfoId, pictures) => (dispatch) => {
  dispatch({
    type: ACTIONS.DEVICES.UPLOAD_ALL_PICTURES_START,
  });
  //
  const promiseArray = pictures.map((img) => {
    const attachmentData = new FormData();
    attachmentData.append("images", img);

    return axios.post(`${API_ENDPOINTS.DEVICES}/${selectedDeviceInfoId}/images`, attachmentData);
  });
  return axios
    .all(promiseArray)
    .then((res) => {
      let images = [];
      res.forEach((element) => {
        images = element.data.images.length > images.length ? element.data.images : images;
      });
      dispatch({
        type: ACTIONS.DEVICES.UPLOAD_ALL_PICTURES,
        payload: images,
      });

      return images;
    })
    .catch(() => {
      dispatch({
        type: ACTIONS.DEVICES.UPLOAD_ALL_PICTURES_FAILURE,
      });
    });
};

export const getDeviceNetWorkHistory = (devicesId, fromUtc, toUtc) => {
  return axios.get(`${API_ENDPOINTS.DEVICES}/${devicesId}/network-info?fromUtc=${fromUtc}&toUtc=${toUtc}`);
};

export const getDeviceDebugMessages = (deviceId, fromUtc, toUtc, { page = 1, perPage = 10, paginate = true } = {}) => {
  const params = paginate ? { fromUtc, toUtc, page, perPage } : { fromUtc, toUtc, paginate: false };
  return axios.get(`${API_ENDPOINTS.DEVICES}/${deviceId}/debug-messages`, { params });
};
